var _path, _path2, _path3, _path4, _path5, _circle, _path6, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReferrals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5439 20.3711V35.1564C14.5439 36.5767 15.0695 38.6859 17.6611 38.6859C20.2527 38.6859 20.9135 36.5767 20.9135 35.1564V25.7454C20.9135 24.8828 21.3514 23.1578 23.103 23.1578C24.8546 23.1578 25.7119 23.1578 26.1763 23.1578",
    stroke: "#FF8165",
    strokeWidth: 0.777773,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81201 13.332C9.3154 16.6957 11.6308 19.4323 15.1647 19.4323C17.8238 19.4323 20.0479 16.9307 20.8023 13.332",
    stroke: "#1552E8",
    strokeWidth: 0.777773,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0269 20.3711V35.1564C15.0269 36.5767 15.5524 38.6859 18.144 38.6859C20.7356 38.6859 21.3964 36.5767 21.3964 35.1564V25.7454C21.3964 24.8828 21.8343 23.1578 23.5859 23.1578C25.3375 23.1578 26.1948 23.1578 26.6592 23.1578",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4585 5.25781V13.4188C8.52485 15.6747 9.89164 20.1864 14.828 20.1864C19.7644 20.1864 21.1312 15.6747 21.1976 13.4188V5.25781",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4585 11.6641C9.18834 13.1237 11.484 16.0431 14.828 16.0431C18.172 16.0431 20.4677 13.1237 21.1976 11.6641",
    stroke: "#081E54",
    strokeWidth: 1.14285,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.45842,
    cy: 3.45549,
    r: 2.36286,
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.14285
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1972 5.81835C22.5022 5.81835 23.56 4.76046 23.56 3.45549C23.56 2.15052 22.5022 1.09264 21.1972 1.09264C19.8922 1.09264 18.8343 2.15052 18.8343 3.45549C18.8343 4.76046 19.8922 5.81835 21.1972 5.81835Z",
    fill: "#E7EDFF",
    stroke: "#081E54",
    strokeWidth: 1.14285
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6205,
    cy: 23.1415,
    r: 2.60469,
    stroke: "#081E54",
    strokeWidth: 0.714281
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.6374,
    cy: 23.1203,
    r: 1.68284,
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferrals);
export default __webpack_public_path__ + "static/media/Referrals.357caa9c831b5eccf5d9c508fb9ae07c.svg";
export { ForwardRef as ReactComponent };